import { render, staticRenderFns } from "./toBeSettledListChildrenSecond.vue?vue&type=template&id=76fbd018&scoped=true"
import script from "./toBeSettledListChildrenSecond.vue?vue&type=script&lang=js"
export * from "./toBeSettledListChildrenSecond.vue?vue&type=script&lang=js"
import style0 from "./toBeSettledListChildrenSecond.vue?vue&type=style&index=0&id=76fbd018&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76fbd018",
  null
  
)

export default component.exports